import React from "react";

export type PopoverProps = {
  title: string;
};
const Popover = ({ title }: PopoverProps) => {
  return (
    <div className="flex flex-row  relative z-10 ">
      <div className="tooltip light top center z-10">
        <span className="text">{title}</span>
      </div>
    </div>
  );
};

export default Popover;
